/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Add_New_ShortInputs */

const en_read_along_add_new_short = /** @type {(inputs: Read_Along_Add_New_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add New`)
};

const es_read_along_add_new_short = /** @type {(inputs: Read_Along_Add_New_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar`)
};

/**
* | output |
* | --- |
* | "Add New" |
*
* @param {Read_Along_Add_New_ShortInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_add_new_short = /** @type {((inputs?: Read_Along_Add_New_ShortInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Add_New_ShortInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_add_new_short(inputs)
	return en_read_along_add_new_short(inputs)
});